import { request } from './request';

export async function getSuburbs(
  postalCode: string,
  abortController?: AbortController,
  handleErrorResponse?: (errorMessage: string, errorDetails: any) => void,
): Promise<string[] | undefined> {
  const res = await request(
    `suburbs?postalCode=${postalCode}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    false,
    true,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    const suburbValue = res.result?.suburb
    return Array.isArray(suburbValue) ? suburbValue : [];
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the suburbs GET endpoint', res);
  }
}
